module.exports = __webpack_public_path__ + "static/pwa-f575307c22214dd5a07c7d1c8a698ba0.svg";